<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户">
                  <!-- <el-input  v-model="queryForm.userId"></el-input> -->
                  <GridSelectU title="选择用户" style="width: 200px;" labelName="userName" labelValue="id" :value="queryForm.userId" :limit='1'
                    size='small' placeholder='请选择用户' @getValue="getSeachValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="平台">
                  <!-- <el-input style="width: 200px;" v-model="queryForm.platform"></el-input> -->
                  <el-select style="width: 200px;" v-model="queryForm.platform" placeholder="请选择平台">
                      <el-option v-for="item in platformList" :key="item.key" :label="item.value" :value="item.key"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="任务标题">
                  <el-input style="width: 200px;" v-model="queryForm.taskName"></el-input>
              </el-form-item>
              <el-form-item label="房间容纳人数">
                  <el-input style="width: 200px;" v-model="queryForm.roomSize"></el-input>
              </el-form-item>
              <el-form-item label="房间已进人数">
                  <el-input style="width: 200px;" v-model="queryForm.currentSize"></el-input>
              </el-form-item>
              <el-form-item label="房间状态">
                  <!-- <el-input style="width: 200px;" v-model="queryForm.status"></el-input> -->
                  <el-select style="width: 200px;" v-model="queryForm.status" placeholder="请选择房间状态">
                      <el-option v-for="item in statusList" :key="item.key" :label="item.value" :value="item.key"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="截止时间">
                  <el-input style="width: 200px;" v-model="queryForm.deadline"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMcnTaskFollowList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <!-- <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMcnTaskFollow"
        >新建</el-button> -->
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMcnTaskFollow(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMcnTaskFollow(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportMcnTaskFollowList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshMcnTaskFollowList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mcnTaskFollowList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
        <template slot-scope='scope'>
            <div v-if="scope.row.user">
              <div style='text-align: left'>账号：{{ scope.row.user.userName }}</div>
              <div style='text-align: left'>手机：{{ scope.row.user.userMobile }}</div>
              <div style='text-align: left'>昵称：{{ scope.row.user.userNickname }}</div>
              <div style='text-align: left'>姓名：{{ scope.row.user.userRealname }}</div>
            </div>
            <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="platform"
        label="平台"
        width="180"
      >
        <template slot-scope='scope'>
          {{ platformListItem(scope.row.platform) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="taskName"
        label="任务标题"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="roomSize"
        label="房间容纳人数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="currentSize"
        label="房间已进人数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="status"
        label="房间状态"
        width="180"
      >
        <template slot-scope='scope'>
          {{ statusListItem(scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="deadline"
        label="截止时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMcnTaskFollow(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editMcnTaskFollow(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteMcnTaskFollow(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mcnTaskFollowStates[mcnTaskFollowState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mcnTaskFollow"
          ref="mcnTaskFollowForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户"
            prop="userId"
          >
            <!-- <el-input
              size="small"
              v-model="mcnTaskFollow.userId"
              :disabled="mcnTaskFollowState == 'check'"
            ></el-input> -->
            <GridSelectU style="width: 200px;" labelName="userName" :disabled="mcnTaskFollowState == 'check'"
              labelValue="id" title="选择用户" :value="mcnTaskFollow.userId" :limit='1' size='small' placeholder='请选择用户'
              @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
            </GridSelectU>
          </el-form-item>
          <el-form-item
            label="平台"
            prop="platform"
          >
            <!-- <el-input
              size="small"
              style="width: 200px;"
              v-model="mcnTaskFollow.platform"
              :disabled="mcnTaskFollowState == 'check'"
            ></el-input> -->
            <el-select style="width: 200px;" v-model="mcnTaskFollow.platform" placeholder="请选择平台" :disabled="mcnTaskFollowState == 'check'">
                <el-option v-for="item in platformList" :key="item.key" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="任务标题"
            prop="taskName"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="mcnTaskFollow.taskName"
              :disabled="mcnTaskFollowState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="房间容纳人数"
            prop="roomSize"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="mcnTaskFollow.roomSize"
              :disabled="mcnTaskFollowState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="房间已进人数"
            prop="currentSize"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="mcnTaskFollow.currentSize"
              :disabled="mcnTaskFollowState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="房间状态"
            prop="status"
          >
            <!-- <el-input
              size="small"
              style="width: 200px;"
              v-model="mcnTaskFollow.status"
              :disabled="mcnTaskFollowState == 'check'"
            ></el-input> -->
            <el-select style="width: 200px;" v-model="mcnTaskFollow.status" placeholder="请选择房间状态" :disabled="mcnTaskFollowState == 'check'">
                <el-option v-for="item in statusList" :key="item.key" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="截止时间"
            prop="deadline"
          >
            <!-- <el-input
              size="small"
              style="width: 200px;"
              v-model="mcnTaskFollow.deadline"
              :disabled="mcnTaskFollowState == 'check'"
            ></el-input> -->
            <el-date-picker
                :disabled="mcnTaskFollowState == 'check'"
                v-model="mcnTaskFollow.deadline"
                type="datetime"
                style="width: 200px;"
                placeholder="选择日期时间"
                size="small"
                format='yyyy-MM-dd HH:mm:ss'
                value-format='yyyy-MM-dd HH:mm:ss'>
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mcnTaskFollowState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import { USER,USER_SEARCH } from '@/utils/constant.js';
import GridSelectU from '@/components/gridselect';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMcnTaskFollowList();
                    this.getMcnTaskFollowList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMcnTaskFollowList();
                    this.getMcnTaskFollowList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     userId: '', //用户
                     platform: '', //平台
                     taskName: '', //任务标题
                     roomSize: '', //房间容纳人数
                     currentSize: '', //房间已进人数
                     status: '', //房间状态
                     deadline: '', //截止时间
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mcnTaskFollowState: 'add',
                mcnTaskFollowStates: {
                    add: '新建房间',
                    check: '查看房间',
                    edit: '修改房间'
                },
                platformList: [],
                multipleSelection: [],
                mcnTaskFollowList: [],
                mcnTaskFollow: {
                    id: '', //ID
                    userId: '', //用户
                    platform: '', //平台
                    taskName: '', //任务标题
                    roomSize: '', //房间容纳人数
                    currentSize: '', //房间已进人数
                    status: '', //房间状态
                    deadline: '', //截止时间
                },
                btnLoading: false,
                statusList: [],
                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    platform: [{ required: true, message: '平台不能为空', trigger: 'blur' }],
                    taskName: [{ required: true, message: '任务标题不能为空', trigger: 'blur' }],
                    roomSize: [{ required: true, message: '房间容纳人数不能为空', trigger: 'blur' }],
                    currentSize: [{ required: true, message: '房间已进人数不能为空', trigger: 'blur' }],
                    status: [{ required: true, message: '房间状态不能为空', trigger: 'blur' }],
                    deadline: [{ required: true, message: '截止时间不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getMcnTaskFollowList();
            this.getplatformList();
            this.getstatusList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetMcnTaskFollowList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mcnTaskFollowList = [];
            },
            getplatformList(){
              get(`/mpp/utils/getEnum`,{enumType: 'mcn_platform_type'}).then((res)=>{
                this.platformList = res.enumList
              })
            },
            getstatusList(){
              get(`/mpp/utils/getEnum`,{enumType: 'mcn_room_task_status'}).then((res)=>{
                this.statusList = res.enumList
              })
            },
            statusListItem(key){
              for (const i in this.statusList) {
                if(this.statusList[i].key == key){
                  return this.statusList[i].value
                }
              }
            },
            platformListItem(key){
              for (const i in this.platformList) {
                if(this.platformList[i].key == key){
                  return this.platformList[i].value
                }
              }
            },
            // 搜索用户
            getSeachValueUser(value){
              this.queryForm.userId = value
            },
            getValueUser(value) {
              this.mcnTaskFollow.userId = value
            },
            resetDialog() {
                this.mcnTaskFollowState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户
                      platform: '', //平台
                      taskName: '', //任务标题
                      roomSize: '', //房间容纳人数
                      currentSize: '', //房间已进人数
                      status: '', //房间状态
                      deadline: '', //截止时间
                };
                this.getMcnTaskFollowList();
            },
            closeDialog() {
                this.showDialog = false
                this.mcnTaskFollow = {
                      id: '', //ID
                      userId: '', //用户
                      platform: '', //平台
                      taskName: '', //任务标题
                      roomSize: '', //房间容纳人数
                      currentSize: '', //房间已进人数
                      status: '', //房间状态
                      deadline: '', //截止时间
                };
            },
            submitForm() {
                if (this.mcnTaskFollowState == 'add') {
                    this.$refs.mcnTaskFollowForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mcn/follow/add`,{ ...this.mcnTaskFollow }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMcnTaskFollowList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.mcnTaskFollowState == 'edit') {
                    this.$refs.mcnTaskFollowForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.mcnTaskFollow.user
                            post(`/mcn/follow/edit`,{ ...this.mcnTaskFollow }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMcnTaskFollowList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addMcnTaskFollow() {
                this.showDialog = true;
                this.mcnTaskFollowState = 'add';
            },
            checkMcnTaskFollow(mcnTaskFollowId) {
                console.log(mcnTaskFollowId);
                this.currentMcnTaskFollowId = mcnTaskFollowId;

                this.getMcnTaskFollowById();
                this.showDialog = true;
                this.mcnTaskFollowState = 'check';
            },
            editMcnTaskFollow(mcnTaskFollowId) {
                console.log('mcnTaskFollow', mcnTaskFollowId);
                if (mcnTaskFollowId) {
                    this.currentMcnTaskFollowId = mcnTaskFollowId;
                    this.getMcnTaskFollowById();
                } else {
                    this.mcnTaskFollow = { ...this.mcnTaskFollow, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mcnTaskFollowState = 'edit';
            },
            deleteMcnTaskFollow(mcnTaskFollowId) {
                let ids = '';
                if (mcnTaskFollowId) {
                    ids = mcnTaskFollowId;
                } else {
                    ids = this.multipleSelection.map((mcnTaskFollow) => mcnTaskFollow.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mcn/follow/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMcnTaskFollowList();
                                this.getMcnTaskFollowList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMcnTaskFollowList() {
                this.resetMcnTaskFollowList();
                this.getMcnTaskFollowList();
            },
            getMcnTaskFollowList(query = {}) {
                this.loading = true;
                get(`/mcn/follow/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mcnTaskFollowList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getMcnTaskFollowById() {
                get(`/mcn/follow/get`,{ id: this.currentMcnTaskFollowId }).then((res) =>{
                    if(res.success){
                      this.mcnTaskFollow = { ...this.mcnTaskFollow, ...res.mcnTaskFollow };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMcnTaskFollowList() {
                //this.btnLoading = true;
                exprotExcel(`/mcn/follow/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mcn/follow/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mcn/follow/importData`,formData);
              this.refreshMcnTaskFollowList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMcnTaskFollowList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMcnTaskFollowList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>